import React  from 'react';

export default function renderFormulaGroupListHeader(id, props) {
    return (
        <div className={Classes('gd-field-string-group-list-header', props.className)}>
            <div className="group-list-header-value">{props.data.value ? props.data.value : "Not set"}</div>
        </div>
    );
}